"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Chip = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classnames = _interopRequireDefault(require("classnames"));

var _excluded = ["variant", "size", "children", "active", "startIcon", "endIcon", "className", "href", "onClick", "component"];

var Chip = function Chip(props) {
  var _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'rounded' : _props$variant,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      children = props.children,
      active = props.active,
      startIcon = props.startIcon,
      endIcon = props.endIcon,
      className = props.className,
      href = props.href,
      onClick = props.onClick,
      component = props.component,
      restProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var Component = getChipComponent(props);
  return (0, _preact.h)(Component, (0, _extends2.default)({}, restProps, {
    onClick: onClick,
    href: (0, _absoluteUrlRuntime.resolveUrl)(href),
    className: (0, _classnames.default)('chip', className, "chip--size-".concat(size), "chip--variant-".concat(variant), {
      'chip--active': active,
      'chip--interactive': onClick || href
    })
  }), startIcon && (0, _preact.h)("span", {
    className: "chip-icon--start"
  }, startIcon), (0, _preact.h)("span", {
    className: "chip-label"
  }, children), endIcon && (0, _preact.h)("span", {
    className: "chip-icon--end"
  }, endIcon));
};

exports.Chip = Chip;
var _default = Chip;
exports.default = _default;

var getChipComponent = function getChipComponent(props) {
  var component = props.component,
      href = props.href,
      onClick = props.onClick;

  if (component) {
    // the case when component prop is passed manually
    return component;
  }

  if (href) {
    return 'a';
  }

  if (onClick) {
    return 'button';
  }

  return 'span';
};